export class CreatePscEndpointInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetService",
            "baseName": "targetService",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "fqdn",
            "baseName": "fqdn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreatePscEndpointInput.attributeTypeMap;
    }
    constructor() {
    }
}
